import { unique } from './unique';

export const extractMentions = (text: string): ({ user: string } | { guest: string })[] => {
  return unique(
    text.match(/\[\[@MENTION=(.*?)\]\]/g)?.map(mention => {
      const userId = mention.replace('[[@MENTION=', '').replace(']]', '');
      return { user: userId };
    }) || [],
    'user'
  );
};
